import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, UserIcon, StethoscopeIcon, MapPinIcon } from 'lucide-react';
interface BookingFormProps {
  persona: 'patient' | 'receptionist';
}
export function BookingForm({
  persona
}: BookingFormProps) {
  const [formData, setFormData] = useState({
    patientName: '',
    patientPhone: '',
    patientEmail: '',
    doctor: '',
    date: '',
    time: '',
    room: '',
    appointmentType: '',
    notes: ''
  });
  const doctors = ['Dr. Sarah Johnson - Cardiologist', 'Dr. Michael Chen - Neurologist', 'Dr. Emily Davis - Pediatrician', 'Dr. James Wilson - Orthopedic'];
  const rooms = ['Room 101', 'Room 102', 'Room 103', 'Room 104', 'Room 105'];
  const appointmentTypes = ['Consultation', 'Follow-up', 'Check-up', 'Emergency', 'Routine'];
  const timeSlots = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM'];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Appointment booked successfully!');
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-102">
      <h2 className="text-2xl font-bold mb-6" data-id="element-103">Book New Appointment</h2>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-104">
        {/* Patient Information - Only show for receptionist */}
        {persona === 'receptionist' && <div className="space-y-4 p-4 bg-gray-50 rounded-lg" data-id="element-105">
            <h3 className="font-semibold flex items-center space-x-2" data-id="element-106">
              <UserIcon className="w-5 h-5 text-blue-600" data-id="element-107" />
              <span data-id="element-108">Patient Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-109">
              <div data-id="element-110">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-111">
                  Patient Name *
                </label>
                <input type="text" required value={formData.patientName} onChange={e => setFormData({
              ...formData,
              patientName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Enter patient name" data-id="element-112" />
              </div>
              <div data-id="element-113">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-114">
                  Phone Number *
                </label>
                <input type="tel" required value={formData.patientPhone} onChange={e => setFormData({
              ...formData,
              patientPhone: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Enter phone number" data-id="element-115" />
              </div>
              <div className="md:col-span-2" data-id="element-116">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-117">
                  Email Address
                </label>
                <input type="email" value={formData.patientEmail} onChange={e => setFormData({
              ...formData,
              patientEmail: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Enter email address" data-id="element-118" />
              </div>
            </div>
          </div>}
        {/* Appointment Details */}
        <div className="space-y-4" data-id="element-119">
          <h3 className="font-semibold flex items-center space-x-2" data-id="element-120">
            <CalendarIcon className="w-5 h-5 text-blue-600" data-id="element-121" />
            <span data-id="element-122">Appointment Details</span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-123">
            <div data-id="element-124">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-125">
                Select Doctor *
              </label>
              <select required value={formData.doctor} onChange={e => setFormData({
              ...formData,
              doctor: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-126">
                <option value="" data-id="element-127">Choose a doctor</option>
                {doctors.map(doctor => <option key={doctor} value={doctor} data-id="element-128">
                    {doctor}
                  </option>)}
              </select>
            </div>
            <div data-id="element-129">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-130">
                Appointment Type *
              </label>
              <select required value={formData.appointmentType} onChange={e => setFormData({
              ...formData,
              appointmentType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-131">
                <option value="" data-id="element-132">Select type</option>
                {appointmentTypes.map(type => <option key={type} value={type} data-id="element-133">
                    {type}
                  </option>)}
              </select>
            </div>
            <div data-id="element-134">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-135">
                Date *
              </label>
              <input type="date" required value={formData.date} onChange={e => setFormData({
              ...formData,
              date: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-136" />
            </div>
            <div data-id="element-137">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-138">
                Time Slot *
              </label>
              <select required value={formData.time} onChange={e => setFormData({
              ...formData,
              time: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-139">
                <option value="" data-id="element-140">Select time</option>
                {timeSlots.map(time => <option key={time} value={time} data-id="element-141">
                    {time}
                  </option>)}
              </select>
            </div>
            <div data-id="element-142">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-143">
                Room *
              </label>
              <select required value={formData.room} onChange={e => setFormData({
              ...formData,
              room: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-144">
                <option value="" data-id="element-145">Select room</option>
                {rooms.map(room => <option key={room} value={room} data-id="element-146">
                    {room}
                  </option>)}
              </select>
            </div>
          </div>
          <div data-id="element-147">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-148">
              Additional Notes
            </label>
            <textarea value={formData.notes} onChange={e => setFormData({
            ...formData,
            notes: e.target.value
          })} rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Any special requirements or notes..." data-id="element-149" />
          </div>
        </div>
        {/* Submit Button */}
        <div className="flex justify-end space-x-4" data-id="element-150">
          <button type="button" className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-151">
            Cancel
          </button>
          <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-152">
            Book Appointment
          </button>
        </div>
      </form>
    </div>;
}